import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { DayjsModule, SharedModule } from '@leandredev/common_ng_14';

import { ParametreBooleanFormModule } from 'src/app/generated/ui/form/ParametreBoolean/ParametreBoolean.module';
import { ParametreDateFormModule } from 'src/app/generated/ui/form/ParametreDate/ParametreDate.module';
import { ParametreDocumentFormModule } from 'src/app/generated/ui/form/ParametreDocument/ParametreDocument.module';

import { ParametreListFormModule } from 'src/app/generated/ui/form/ParametreList/ParametreList.module';
import { ParametreNumberFormModule } from 'src/app/generated/ui/form/ParametreNumber/ParametreNumber.module';

import { ParametreStringFormModule } from 'src/app/generated/ui/form/ParametreString/ParametreString.module';
import { TemplateFieldUIListSubDocComponent } from './TemplateField.component';

import { ParameterTabFormModule } from 'src/app/generated/ui/form/ParameterTab/ParameterTab.module';
import { ParameterGroupFormModule } from 'src/app/generated/ui/form/ParameterGroup/ParameterGroup.module';
import { ParameterDividerFormModule } from 'src/app/generated/ui/form/ParameterDivider/ParameterDivider.module';
import { ParameterListActServiceFormModule } from 'src/app/generated/ui/form/ParameterListActService/ParameterListActService.module';
import { ParametreCurrencyFormModule } from 'src/app/generated/ui/form/ParametreCurrency/ParametreCurrency.module';
import { ParameterComponentFormComponent } from './ParameterComponent/ParameterComponent.component';
import { ParameterComponentListFormComponent } from './ParameterComponentList/ParameterComponentList.component';
import { ParameterTextAreaFormModule } from 'src/app/generated/ui/form/ParameterTextArea/ParameterTextArea.module';
import { ParameterDocumentLinkFormModule } from 'src/app/generated/ui/form/ParameterDocumentLink/ParameterDocumentLink.module';
import { ParametreDossierFormModule } from 'src/app/generated/ui/form/ParametreDossier/ParametreDossier.module';
// Copier les composant suivant
//  .generated/ui/form/ParameterComponent
//  .generated/ui/form/ParameterComponentListFormComponent

@NgModule({
  declarations: [TemplateFieldUIListSubDocComponent, ParameterComponentFormComponent, ParameterComponentListFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatExpansionModule,
    MatInputModule,
    DayjsModule,
    SharedModule,
    MatButtonModule,
    MatMenuModule,
    DragDropModule,
    ParametreDateFormModule,
    ParametreNumberFormModule,
    ParametreBooleanFormModule,
    ParametreDocumentFormModule,
    ParametreListFormModule,

    ParametreStringFormModule,

    ParameterTabFormModule,
    ParameterGroupFormModule,
    ParameterDividerFormModule,
    ParameterListActServiceFormModule,
    ParametreCurrencyFormModule,
    ParameterDocumentLinkFormModule,
    ParameterTextAreaFormModule,
    ParametreDossierFormModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatExpansionModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule,
    DragDropModule,
    DayjsModule,
    SharedModule,
    ParametreDateFormModule,
    ParametreNumberFormModule,
    ParametreBooleanFormModule,
    ParametreDocumentFormModule,
    ParametreListFormModule,
    ParameterDocumentLinkFormModule,
    ParametreStringFormModule,
    TemplateFieldUIListSubDocComponent,
    ParameterTabFormModule,
    ParameterGroupFormModule,
    ParameterDividerFormModule,
    ParameterListActServiceFormModule,
    ParametreCurrencyFormModule,
    ParameterTextAreaFormModule,
    ParametreDossierFormModule,
    ParameterTextAreaFormModule
  ]
})
export class TemplateFieldListSubDocModule {}
